import { useQuery, keepPreviousData } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Catalogos de filtros del informe (bandejas, prioridades, temas, agentes,
// clientes, ...). Cambian poco -> staleTime largo, cacheado por sede.
export const useInformeFiltros = (headquarter) =>
  useQuery({
    queryKey: ticketsKeys.informeFiltros(headquarter),
    queryFn: async () => {
      const data = await ticketsService.listarFiltrosInforme({ headquarter });
      return data && typeof data === 'object' ? data : {};
    },
    enabled: Boolean(headquarter),
    staleTime: 10 * 60 * 1000,
  });

// Informe de actividad para un rango de fechas (+ filtros opcionales).
// Gated por rango obligatorio; keepPreviousData evita parpadeo al ajustar
// filtros o fechas. Normaliza para que series sea siempre un array.
export const useInformeActividad = (headquarter, filtros = {}) =>
  useQuery({
    queryKey: ticketsKeys.informeActividad(headquarter, filtros),
    queryFn: async () => {
      const data = await ticketsService.obtenerInformeActividad({ headquarter, ...filtros });
      return {
        rango: data?.rango || null,
        resumen: data?.resumen || null,
        series: Array.isArray(data?.series) ? data.series : [],
        desglose: data?.desglose || {},
      };
    },
    enabled: Boolean(headquarter && filtros.fecha_inicio && filtros.fecha_fin),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });

export default useInformeActividad;
